export enum ErrorCode {
  VALIDATION_ERROR = 1001,
  DATABASE_ERROR,
  INTERNAL_SERVER_ERROR,
  RESOURCE_NOT_FOUND,
  UNAUTHENTICATED,
  FORBIDDEN,
  MASTER_CANNOT_PERFORM_IN_TENANT,
  PREFECTURE_NOT_EXITS,
  LINE_INVALID_CREDENTIALS = 3001,
  LINE_CONNECTION_FAILED,
  LINE_FETCH_FRIENDS_FAILED,
  LINE_ACCOUNT_NOT_FOUND,
  LINE_ACCOUNT_EXISTS,
  LINE_ACCOUNT_CANNOT_ATTACH_WEBHOOK,
  LINE_ACCOUNT_INACTIVE,
  CREATE_TENANT_FAILED = 5001,
  TEST_PUSH_ERROR = 6000,
  CREATE_DELIVERY_MESSAGE_ERROR,
  DELIVERY_MESSAGE_UPLOAD_CONTENT_FILE_ERROR,
  DELIVERY_MESSAGE_DO_NOT_TEST_PUSH,
  DELIVERY_MESSAGE_UPLOAD_LIMITED,
  DELIVERY_MESSAGE_ALREADY_SCHEDULED,
  DELIVERY_MESSAGE_CONTENT_INVALID,
  DELIVERY_MESSAGE_CANNOT_CANCEL_MESSAGE,
  DELIVERY_MESSAGE_DEADLINE_HAS_PASSED,
  DELIVERY_MESSAGE_CANNOT_DESTROY_MESSAGE,
  DELIVERY_MESSAGE_CANNOT_UPDATE_MESSAGE,
  DELIVERY_MESSAGE_CANNOT_SCHEDULED_WITH_INACTIVE_FRIEND,
  DELIVERY_MESSAGE_UPLOAD_CONTENT_TEST_FILE_ERROR = 6013,
  DELIVERY_MESSAGE_TNC_NOT_CONFIRMED = 6015,
  DELIVERY_MESSAGE_FILE_HEADER_LINE_UID_MISSING = 6019,
  DELIVERY_MESSAGE_FILE_HEADER_ACCOUNT_NAME_MISSING,
  DELIVERY_MESSAGE_FILE_COLUMN_COUNT_MISMATCH,
  CANNOT_RESET_MASTER_PASSWORD = 7000,
  NOT_RESET_PASSWORD_YET,
  ALREADY_RESET_PASSWORD,
}

export enum ErrorFileRule {
  REQUIRED = 'Required',
  DISTINCT = 'Distinct',
}
